import React, { Component } from 'react'
import axios from 'axios'
import Cookie from 'js-cookie'
import { Redirect } from 'react-router-dom'

import { Title } from '../../atoms/title'
import { Button } from '../../atoms/button'
import { Label } from '../../atoms/label'
import { Loader } from '../../atoms/loader'
import { Inputbox } from '../../atoms/inputbox'

import styles from '../../pages/auth/auth.module.css'

const LoginURL = 'https://us-central1-onlive-poker-dev.cloudfunctions.net/admin/login'

export class Login extends Component {

    state = {
        error: null,
        loading: false,
    }

    onDetailsChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = () => {
        if ('email' in this.state && !!this.state.email) {
            if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.state.email)) {
                if ('password' in this.state && !!this.state.password) {
                    this.setState({ loading: true })
                    axios.post(LoginURL, { "email": this.state.email, "password": this.state.password })
                        .then(response => {
                            if (response.status === 200) {
                                Cookie.set('onliveAdminId', response.data.user)
                                this.setState({ error: null, loading: false })
                            } else {
                                this.setState({ error: 'Unexpected response. Please retry', loading: false })
                            }
                        })
                        .catch(error => {
                            if ('response' in error && error.response && 'status' in error.response && error.response.status === 401) {
                                if (error.response.data && 'error' in error.response.data && error.response.data.error && 'message' in error.response.data.error) {
                                    this.setState({ error: error.response.data.error.message, loading: false })
                                } else {
                                    this.setState({ error: 'The password is invalid', loading: false })
                                }
                            } else {
                                this.setState({ error: 'An error occured, please try again', loading: false })
                            }
                        })
                } else {
                    this.setState({ error: 'Please enter the password' })
                }
            } else {
                this.setState({ error: 'Please enter a valid email ID' })
            }
        } else {
            this.setState({ error: 'Please enter the email ID' })
        }
    }

    render() {
        if (!!Cookie.get('onliveAdminId') && Cookie.get('onliveAdminId') !== '') {
            return <Redirect to="/" />
        } else {
            return <div className={styles.templateContainer}>
                <div className={styles.header}>
                    <Title bold>Login</Title>
                </div>
                <div className={styles.body}>
                    <Inputbox name="email" placeholder="Email ID" type="email" onChange={this.onDetailsChange} />
                    <Inputbox name="password" placeholder="Enter password" type="password" onChange={this.onDetailsChange} />
                    {this.state.error && <Label error center>{this.state.error}</Label>}
                    <Label info onClick={this.props.toggleTemplate}>Forgot password?</Label>
                    <Button primary submit onClick={this.onSubmit}>Login{this.state.loading && <Loader small />}</Button>
                </div>
            </div>
        }
    }
}